export default __webpack_public_path__ + "static/media/mountain.f9dd0e08.png~";